import { ICheckServiceRequest } from '../../../../../repositories/monolith-python/v1/check-service';
import {
  checkBusinessCenterCategory,
  checkJKCategory,
  getCoordinates,
  getJKId,
  getBusinessCenterId,
  isObjectSplits,
  getLocationPathWithUserGeoFallback,
} from '../../../../../utils/offer';
import {
  ICheckoutInfoState,
  IOfferState,
  IUserState,
} from '../../../../reducers';
import { getIsCalltrackingPhoneChanged } from './getIsCalltrackingPhoneChanged';
import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';

interface IGetCheckServiceParams {
  offer: IOfferState;
  user: IUserState;
  checkoutInfo: ICheckoutInfoState;
  terms: Array<ICheckPublishTermSchema>;
  isServiceChanged: boolean;
}

export function getCheckServiceParams(params: IGetCheckServiceParams): ICheckServiceRequest {
  const {
    offer,
    user,
    checkoutInfo,
    terms,
    isServiceChanged,
  } = params;

  const { id: objectId, category } = offer;

  const {
    autoProlongInfo: { isChecked: autoProlong },
  } = checkoutInfo;

  const isJKCategory = checkJKCategory(offer);
  const isBusinessCenterCategory = checkBusinessCenterCategory(offer);
  const newObjectId = getJKId(offer);
  const businessShoppingCenterId = getBusinessCenterId(offer);
  const { lat, lng } = getCoordinates(offer);
  const locationPath = getLocationPathWithUserGeoFallback(offer, user);
  const isMultiListing = isObjectSplits(offer);
  const userHasChangedCalltrackingPhone = getIsCalltrackingPhoneChanged(offer);

  return {
    ...(isJKCategory && { newObjectId }),
    ...(isBusinessCenterCategory && { businessShoppingCenterId }),
    objectId,
    category,
    locationPath: locationPath.join(','),
    autoProlong,
    terms,
    latitude: lat,
    longitude: lng,
    isMultiListing,
    userHasChangedServices: isServiceChanged,
    userHasChangedCalltrackingPhone,
  };
}
